import { render, staticRenderFns } from "./StclPD_Details.vue?vue&type=template&id=2cb40069"
import script from "./StclPD_Details.vue?vue&type=script&lang=js"
export * from "./StclPD_Details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports